import useHttpLoader from '@/shared/hooks/useHttpLoader'
import useInputFile from '@/shared/hooks/useInputFile'
import userApi from '../../user.api'
import filesUtils from '@/shared/Files/files.utils'
import { IAvatar } from '@/pages/Users/users.types'

interface IProps {
  onAvatarUpload: (avatar: IAvatar) => void
}

const useAvatarSettingsCtrl = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const handleOnFiles = async (files: File[]): Promise<IAvatar | null> => {
    if (!files || files.length === 0) return
    const { errors, file } = filesUtils.validateFile(files[0], 2, ['image/png', 'image/jpeg', 'image/jpg'])

    if (errors.length > 0) {
      alert(`Файл с именем "${file.name}" не прошел валидацию: ${errors.join(', ')}`)
    } else {
      const avatarFile = filesUtils.fileWithUnixTimestamp(files[0])
      wait(userApi.updateSelfAvatar(avatarFile), (resp) => {
        if (resp.status === 'success') {
          props.onAvatarUpload(resp.body)
        }
      })
    }
  }

  const fileInputHandler = useInputFile({
    onFiles: handleOnFiles,
    multiple: false,
    accept: 'image/png, image/jpeg, image/jpg',
  })

  return {
    fileInputHandler,
    handleOnFiles,
    avatarLoading: loading,
  }
}

export default useAvatarSettingsCtrl
